import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const SignOutIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <g id="Icon">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.53257 16.958C10.2249 16.958 11.6067 15.5738 11.6067 13.854V12.8905C11.6067 12.4763 11.9425 12.1405 12.3567 12.1405C12.7709 12.1405 13.1067 12.4763 13.1067 12.8905V13.854C13.1067 16.3912 11.0643 18.458 8.53257 18.458H6.3186C3.67574 18.458 1.54321 16.3004 1.54321 13.6512L1.54321 6.34892C1.54321 3.6997 3.67574 1.54211 6.3186 1.54211L8.53257 1.54211C11.0643 1.54211 13.1067 3.60889 13.1067 6.14608L13.1067 7.10958C13.1067 7.52379 12.7709 7.85958 12.3567 7.85958C11.9425 7.85958 11.6067 7.52379 11.6067 7.10958L11.6067 6.14608C11.6067 4.4263 10.2249 3.04212 8.53257 3.04212L6.3186 3.04211C4.51514 3.04211 3.04321 4.51712 3.04321 6.34892L3.04321 13.6512C3.04321 15.483 4.51514 16.958 6.3186 16.958H8.53257ZM15.6279 6.85737L18.2375 9.46868C18.5302 9.76153 18.5302 10.2361 18.2375 10.529L15.6279 13.1403C15.3351 13.4333 14.8602 13.4334 14.5672 13.1406C14.2742 12.8478 14.2741 12.373 14.5669 12.08L15.8972 10.7488H7.70703C7.29282 10.7488 6.95703 10.4131 6.95703 9.99884C6.95703 9.58463 7.29282 9.24884 7.70703 9.24884L15.8972 9.24884L14.5669 7.9177C14.2741 7.62471 14.2742 7.14984 14.5672 6.85704C14.8602 6.56424 15.3351 6.56439 15.6279 6.85737Z"
          fill="#222222"
        />
      </g>
    </svg>
  );
};
